// src/pages/CourseDashboardPage.jsx
import React, { useEffect, useMemo } from 'react';
import '../styles/newsletter-signup.css';
import { useAuth } from '../auth/AuthProvider';
import SEO, { SEO_CONFIG } from '../components/SEO';
import DashboardView from '../features/courses/components/DashboardView';
import { useCourses } from '../features/courses/hooks/useCourses';
import { AUTH_ENABLED } from '../auth/flags';
import { logger } from '../lib/logger';

export default function CourseDashboardPage() {
  const { user, ready, enabled, isSubscribed, subscription, subscriptionLoading } = useAuth();
  
  // Debug subscription state
  logger.log('[Dashboard] Subscription state:', { isSubscribed, subscription, subscriptionLoading });

  const envAuth = AUTH_ENABLED;
  const authEnabled = !!(envAuth && enabled);

  const { courses, continueLearning, status, loading, load, loadAll, toggleBookmark, deleteCourse, pagination } = useCourses({
    authEnabled,
    user,
    ready,
  });

  useEffect(() => { load(); }, [load]);

  // useEffect(() => {
  //   console.log('[auth probe] envAuth=%s enabled=%s authEnabled=%s ready=%s hasUser=%s',
  //     envAuth, enabled, authEnabled, ready, !!user);
  //   if (!authEnabled) return;
  //   if (!ready || !user) return;
  //   (async () => {
  //     try {
  //       // const res = await authApi.getMe({ auth: true });
  //       console.debug('[auth/me]', res);
  //     } catch (e) {
  //       console.warn('[auth/me] failed:', e);
  //     }
  //   })();
  // }, [authEnabled, ready, user, envAuth, enabled]);

  const firstName = useMemo(() => {
    const name = user?.displayName || user?.email || '';
    const token = String(name).trim().split(/\s|@/)[0] || '';
    return token;
  }, [user]);

  return (
    <>
      <SEO {...SEO_CONFIG.dashboard} />
      <DashboardView
        courses={courses}
        continueLearning={continueLearning}
        status={status}
        loading={loading}
        onRefresh={load}
        onLoadAll={loadAll}
        onToggleBookmark={toggleBookmark}
        onDelete={deleteCourse}
        firstName={firstName}
        pagination={pagination}
      />
    </>
  );
}